<template>
  <modal
    :showModal="showModal"
    @close-modal="$emit('close-modal')"
    title="Upload Licenses"
    width="30"
  >
    <div class="particulars-img-wrapper">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 col-lg-12 col-12">
            <label for="" class="label">Type</label>
            <input
              type="text"
              class="input"
              placeholder="-- Enter --"
              v-model="newParticulars.type"
            />
          </div>
          <div class="col-md-12 col-lg-12 col-12">
            <label for="" class="label">License Number</label>
            <input
              type="text"
              class="input"
              placeholder="-- Enter --"
              v-model="newParticulars.licensenumber"
            />
          </div>
          <div class="col-md-12 col-lg-12 col-12">
            <label for="" class="label">Issue Date</label>
            <!-- <input type="text" class="input" v-model="" /> -->
            <el-date-picker
              v-model="newParticulars.issueDate"
              type="date"
              placeholder="Pick a date"
            >
            </el-date-picker>
          </div>
          <div class="col-md-12 col-lg-12 col-12">
            <label for="" class="label">Expiry Date</label>
            <!-- <input type="text" class="input" v-model="" /> -->
            <el-date-picker
              v-model="newParticulars.expirydate"
              type="date"
              placeholder="Pick a date"
            >
            </el-date-picker>
          </div>
          <div class="col-md-12 col-lg-12 col-12">
            <label for="" class="label">Class</label>
            <input
              type="text"
              class="input"
              placeholder="-- Enter --"
              v-model="newParticulars.class"
            />
          </div>
        </div>
      </div>
      <div v-if="!isView">
        <p class="font-semibold text-primary-yellow">Upload Document</p>
      </div>
      <div
        v-if="!isView"
        class="my-3 transform duration-150"
        style="border: 2px dashed gray; padding: 1rem; border-radius: 10px"
      >
        <file-uploader
          @input="handleImageUpload($event)"
          @remove-image="removeImage"
          @getsize="getSize"
          :isUploadingImage="isUploadingImage"
        />
      </div>
      <div  v-if="isView">
        <b class="font-normal block w-full py-2">UPLOADED FILES</b>
        <div class="flex items-center shadow-md bg-white py-2">
          <div class="col-2">
            <img
              style="width: 70px"
              src="@/assets/images/icons/documents.svg"
            />
          </div>
          <div class="col-6">
            <span class="font-semibold"
              ><a class="anchor" :href="fileData.data.url">License.pdf</a></span
            >
            <span class="w-full inline-block"
              >Licenses • {{ fileData.size }}KB</span
            >
          </div>
        </div>
      </div>
      <!-- <pre>{{ newParticulars.expirydate }}</pre> -->
    </div>
    <hr class="my-2" />
    <div v-if="particulars.length">
      <p class="text-lightGrey">UPLOADED FILES</p>
      <div class="flex flex-col">
        <div
          class="flex justify-between items-center mt-4"
          v-for="particular in particulars"
          :key="particular.name"
        >
          <!-- icon -->
          <img
            style="width: 100px; height: 100px"
            src="@/assets/images/icons/documents.svg"
          />
          <div class="font">
            <p>{{ particular.name }}</p>
            <p class="text-blue-400 text-sm">
              {{ particular.particulars.documentnumber }}
              <!-- <span class="text-lightGrey">• 258KB</span> -->
            </p>
          </div>
          <span
            class="cursor-pointer"
            @click="removeParticular(particular.name)"
          >
            <svg
              width="38"
              height="38"
              viewBox="0 0 38 38"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                width="38"
                height="38"
                rx="5"
                transform="matrix(-1 0 0 1 38 0)"
                fill="#C33C50"
                fill-opacity="0.1"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M22.6844 14.2105V13.4737C22.6844 12.6598 22.0247 12 21.2108 12H16.7897C15.9758 12 15.316 12.6598 15.316 13.4737V14.2105H13.1055C12.6985 14.2105 12.3687 14.5404 12.3687 14.9474C12.3687 15.3543 12.6985 15.6842 13.1055 15.6842H13.8423V23.7895C13.8423 25.0103 14.832 26 16.0529 26H21.9476C23.1684 26 24.1581 25.0103 24.1581 23.7895V15.6842H24.895C25.3019 15.6842 25.6318 15.3543 25.6318 14.9474C25.6318 14.5404 25.3019 14.2105 24.895 14.2105H22.6844ZM21.2108 13.4737H16.7897V14.2105H21.2108V13.4737ZM22.6844 15.6842H15.316V23.7895C15.316 24.1964 15.6459 24.5263 16.0529 24.5263H21.9476C22.3545 24.5263 22.6844 24.1964 22.6844 23.7895V15.6842Z"
                fill="#EA3C53"
              />
              <path
                d="M16.7897 17.1579H18.2634V23.0526H16.7897V17.1579Z"
                fill="#EA3C53"
              />
              <path
                d="M19.7371 17.1579H21.2108V23.0526H19.7371V17.1579Z"
                fill="#EA3C53"
              />
            </svg>
          </span>
        </div>
      </div>
    </div>

    <div class="button-wrapper">
      <button @click="$emit('close-modal')">Cancel</button>
      <base-button
        text="Save"
        :disabled="disablethisButton"
        @click="saveLicense"
      />
    </div>
  </modal>
</template>

<script>
import FileUploader from "./UploadDocument.vue";
import moment from "moment"

export default {
  components: { FileUploader },
  props: {
    showModal: Boolean,
    editProps: Object,
    resetDriverLicense: Boolean,
    isView: Boolean,
    particularsName: {
      required: false,
      default: "Licence & Registration",
    },
  },
  data() {
    return {
      newParticulars: {
        url: "",
        expirydate: "",
        class: "",
        issueDate: "",
        type: "",
        license_number: "",
      },
      isUploadingImage: false,
      particulars: [],
      fileSize: 0,
    };
  },
  computed: {
    fileData() {
      return {
        data: this.newParticulars,
        size: this.fileSize,
      };
    },
    disablethisButton() {
      return this.newParticulars?.url.length == 0 ||
        this.newParticulars?.expirydate.length == 0 ||
        this.newParticulars?.issueDate.length == 0 ||
        this.newParticulars?.type.length == 0 ||
        this.newParticulars?.class.length == 0
        ? true
        : false;
    },
  },
  watch: {
    resetDriverLicense(val) {
      val &&
        (this.newParticulars = {
          url: "",
          expirydate: "",
          class: "",
          issueDate: "",
          type: "",
          license_number: "",
        });
    },
  },
  methods: {
    formatDate(val) {
      return moment(val).format("DD/MM/YYYY");
    },
    getSize(val) {
      this.fileSize = Math.floor(val);
    },
    saveLicense() {
      this.$emit("licenseDetail", this.fileData);
      this.closeModal();
    },
    closeModal() {
      this.$emit("close-modal");
    },
    async handleImageUpload(image) {
      this.isUploadingImage = true;
      try {
        let response = await this.uploadImage(image);
        this.newParticulars.url = response;
        this.generateToast("Image uploaded", "success");
        console.log(this.newParticulars);
        this.isUploadingImage = false;
      } catch (error) {
        this.handleError(error);
        this.isUploadingImage = false;
      }
    },
    removeImage() {
      this.newParticulars.imageurl = null;
    },
  },
  mounted() {},
};
</script>

<style scoped>
.particulars-img-wrapper {
  /* border: 1px solid #edf2ef; */
  /* width: 60%; */
  /* margin: 1rem auto; */
  cursor: pointer;
}

.uploaded-img {
  width: 8rem;
  height: auto;
  margin: 1rem auto;
}

.el-date-editor.el-input {
  width: 100%;
  padding-right: 0;
}
</style>
